import Q from 'q';
import _ from 'underscore';

class Model {

	constructor(attributes) {
		for (var attribute_key in attributes) {
			if (!attributes.hasOwnProperty(attribute_key)) { continue; }
			this[attribute_key] = attributes[attribute_key];
		}
		this.loaded_relationships = [];
	}

	static fields() {
		var fields = this.fieldsInternal();
		if (_.indexOf(fields, 'id') === -1) { fields.push('id'); }
		return fields;
	}

	static fieldsInternal() {
		return [];
	}

	static relationships() {
		return [];
	}

	static parseDate(instance, field) {
		if (!instance[field]) { return; }
		instance[field] = new Date(instance[field] * 1000);
	}

	static parse(attributes) {
		var self = this;
		return Q.promise(function (resolve, reject, notify) {

			// Create the new instance.
			var instance = new self(attributes);

			// If we have any relationships, apply them and see if
			// we need to fetch any more information.
			var promises = [];
			var relationships = self.relationships();
			for (var index in relationships) {
				if (!relationships.hasOwnProperty(index)) { continue; }
				(function(relationship) {
					if (typeof(instance[relationship]) !== 'undefined') {
						promises.push(instance.loadRelationship(relationship));
					}
				})(relationships[index]); // Closure to preserve variable value.
			}

			// Once all the relationships are loaded...
			Q.all(promises).then(function () {
				resolve(instance);
			}).fail(reject).done();

		});
	}

	loadRelationship(field) {

		var self = this;

		// If the relationship exists.
		if (_.indexOf(this.loaded_relationships, field) !== -1) {
			return Q.promise(function (resolve, reject, notify) {
				resolve(self);
			});
		}

		// If the field is not an array, make it one.
		if (!Array.isArray(this[field])) {
			this[field] = [this[field]];
		}

		// Get the collection from the first item.
		var collection = false;
		if (this[field].length > 0) {
			collection = ABR.RaceSchedule.Collections[this[field][0].bundle];
		}

		// If we don't have a collection (or items), skip.
		if (!collection) {
			return Q.promise(function (resolve, reject, notify) { resolve(self); });
		}

		// Prepare our promises and results array.
		var promises = [];
		var results = [];
		var index = 0;
		_.each(self[field], function (relationship_def) {

			(function (index, self) {

				// Get the model class.
				var model = ABR.RaceSchedule.Models[relationship_def.bundle];
				if (typeof(model) === 'undefined') { return; } // Skip the relationship.

				// Make sure all our fields are represented.
				var allFieldsRepresented = true;
				model.fields().forEach(function (field) {
					if (typeof(relationship_def[field]) === 'undefined') {
						allFieldsRepresented = false;
					}
				});

				// If they're all represented, update the attribute
				// with a new instance of that model.
				var promise = null;
				if (allFieldsRepresented === true) {
					promise = model.parse(relationship_def)
						.then(function (relationship_model) {
							self[relationship] = relationship_model;
						});
				} else {
					promise = collection.getInstance().fetch({parameters: {id: relationship_def.id}}).then(function (results) {
						if (results.length <= 0) {
							return {};
						} else {
							return results[0];
						}
					}).then(function (relationship_model) {
						results[index] = relationship_model;
					}, function (error) {
						console.log(['Error fetching related entity.', error]);
						results[index] = null;
					});
				}

				promises.push(promise);

			})(index, self);
			index++;

		});

		// Fetch the entity from the collection and return the promise.
		return Q.all(promises).then(function () {
			if (results.length === 1) {
				self[field] = results[0];
			} else { self[field] = results; }
			return self;
		});

	}

}

export default Model;



/** WEBPACK FOOTER **
 ** ./site/sites/all/themes/custom/abr_theme/js/common/Model.js
 **/